import { PolicyLayout, PolicySection } from "@/components/PolicyLayout";

export default function ThirdParty() {
  return (
    <PolicyLayout
      testId="third-party-page"
      seoTitle="Third-Party Services — Foodie Crave"
      seoDescription="The third-party technologies and service providers Foodie Crave uses to support app functionality, discovery, payments, and support."
      seoPath="/third-party"
      title="Third-Party Services"
      updated="October 20, 2026"
    >
      <PolicySection title="1. Overview">
        <p>
          Foodie Crave uses third-party technologies and service providers to support app
          functionality, restaurant discovery, account services, payment processing, technical
          operations, and customer support.
        </p>
      </PolicySection>

      <PolicySection title="2. Google Maps and Google Places">
        <p>
          Foodie Crave uses Google Maps Platform services to support location-based restaurant
          discovery and display relevant place information, including:
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Restaurant and business names</li>
          <li>Business addresses and map locations</li>
          <li>Business details and external links</li>
          <li>Nearby place searches and geographic results</li>
          <li>Maps and location-related features</li>
        </ul>
        <p>
          Google Maps services are subject to Google's applicable terms and privacy policies,
          including attribution and content-use restrictions.
        </p>
      </PolicySection>

      <PolicySection title="3. Account Hosting and Application Infrastructure">
        <p>
          Foodie Crave uses third-party hosting, database, authentication, and infrastructure
          services to operate the application. These providers may process account details,
          application data, authentication records, and technical information as necessary to
          deliver their services.
        </p>
      </PolicySection>

      <PolicySection title="4. Google Play and Subscription Services">
        <p>
          When paid membership functionality is available, purchases and subscriptions may be
          processed through Google Play and RevenueCat. These services may process transaction
          identifiers, purchase history, subscription status, and related technical information.
        </p>
      </PolicySection>

      <PolicySection title="5. Customer Support and Technical Services">
        <p>
          Foodie Crave may use third-party services (including Zoho Forms) to receive and manage
          customer support inquiries, bug reports, and service-related communications.
        </p>
      </PolicySection>

      <PolicySection title="6. External Websites">
        <p>
          Foodie Crave may link to restaurants, vendors, Google Maps listings, and other external
          websites. Foodie Crave does not control the privacy practices or content of independently
          operated third-party websites.
        </p>
      </PolicySection>

      <PolicySection title="7. Updates to Third-Party Services">
        <p>
          Foodie Crave may add, replace, or discontinue service providers as its features evolve.
          Material changes affecting personal information will be reflected in applicable
          disclosures.
        </p>
      </PolicySection>

      <PolicySection title="8. Questions">
        <p>
          For questions about third-party services, contact Foodie Crave through its official
          website or{" "}
          <a
            href="https://forms.zohopublic.com/foodiecrave4ugm1/form/CustomerSupportForm/formperma/RzlQJWKo2FHdmJj54ES7g4Hpv0gkn1cX5RIONNP7omw"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-crave-gold transition-colors duration-300 hover:text-crave-cream"
          >
            Customer Support form
          </a>
          .
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
